<template>
<div id="app">
  <eso-header v-show="headerIsShow"></eso-header>
  <!--<div class="mobile-tips"></div>-->
  <router-view></router-view>
  <eso-footer></eso-footer>
  <eso-sso></eso-sso>
</div>
</template>

<script>
import esoHeader from './components/core/header'
import esoFooter from './components/core/footer'
import esoSso from './components/core/sso'

export default {
  name: 'app',
  components: {
    esoHeader,
    esoFooter,
    esoSso
  },
  data () {
    return {
      headerIsShow: false
    }
  },
  mounted () {
    this.headerIsShow = this.$route.name !== 'index'
  },
  watch: {
    '$route' (to, from) {
      this.headerIsShow = to.name !== 'index'
    }
  }
}
</script>

<style>
/***** css reset******/

* {
  box-sizing: border-box;
}

#app {
  font-size: 12px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  color: #333;
}

html,
body,
#app {
  height: 100%;
}

button,
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit
}

input {
  outline: none;
}


/***** button default******/

.el-button--default {
  background-color: #FF4200;
  color: white;
  border: 1px solid #FF4200;
}

.el-button--default:focus {
  color: #ffffff;
  border-color: #FF4200;
}

.el-button--default:hover {
  color: #ffffff;
  background-color: #FF6834;
  border-color: #FF6834;
}

.el-button--default:active {
  color: #ffffff;
  background-color: #cc3500;
  border-color: #a92b00;
}


/***** button primary******/

.el-button--primary {
  color: #fff;
  background-color: #1376eb;
  border-color: #116ad3;
}

.el-button--primary:focus {
  color: #fff;
  background-color: #1376eb;
  border-color: #116ad3;
}

.el-button--primary:hover {
  color: #ffffff;
  background-color: #4292F0;
  border-color: #4292F0;
}

.el-button--primary:active {
  color: #ffffff;
  background-color: #0F5EBC;
  border-color: #0F5EBC;
}

/***** button info******/

.el-button--info {
  color: #fff;
  background-color: #b0b0b0;
  border-color: #ABABAB;
}

.el-button--info:focus {
  color: #fff;
  background-color: #b0b0b0;
  border-color: #ABABAB;
}

.el-button--info:hover {
  color: #ffffff;
  background-color: #C8C8C8;
  border-color: #BBBBBB;
}

.el-button--info:active {
  color: #ffffff;
  background-color: #A3A3A3;
  border-color: #A3A3A3;
}



/***** css util ******/

.container {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}

@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}

.clearfix {
  *zoom: 1;
}

.clearfix:before,
.clearfix:after {
  display: table;
  line-height: 0;
  content: "";
}

.clearfix:after {
  clear: both;
}

.btn-block {
  width: 100%;
}

.el-col {
  padding-left: 15px;
  padding-right: 15px;
}

.no-left-padding {
  padding-left: 0;
}

.no-lr-padding {
  padding-left: 0;
  padding-right: 0;
}


/***** common style ******/

.eso-panel {
  background-color: white;
  border: 1px solid #ddd;
  padding: 15px;
  color: #555;
  font-size: 14px;
}

.el-tooltip__popper{
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
}
.el-loading-mask{
  z-index: 1000;
}
.el-icon-loading{
  transform-origin:50% 45%;
}
.el-icon-loading:before {
  content: "\e603";
}
.el-icon-loading{
  font-family:"iconfont" !important;
  font-size:12px;
  font-style:normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.mobile-tips{
  display: none;
}
@media screen and (max-width: 1000px) {
  .mobile-tips{
    display: block;
  }
}
.el-select-dropdown__item span{
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
}
@-moz-document url-prefix() {
  .el-scrollbar__wrap{
    overflow-x: hidden;
  }
  .el-scrollbar__bar.is-vertical{
    display:none;
  }
}
_:-ms-lang(x),.el-scrollbar__wrap{
  overflow-x: hidden;
}
_:-ms-lang(x),.el-scrollbar__bar.is-vertical{
  display:none;
}
_:-ms-lang(x),.el-scrollbar__bar.is-horizontal{
  display:none;
}
</style>



// WEBPACK FOOTER //
// App.vue?269dd27a